import { CheckCircleFilled } from '@ant-design/icons';
import { Typography } from 'antd';
import * as React from 'react';

import s from './SuccessStub.module.scss';
import { SUCCESS_STUB_TEXTS } from './texts';

const SuccessStub: React.FC = () => {
  return (
    <div className={s.successStub}>
      <CheckCircleFilled className={s.successStub__icon} />
      <Typography.Title level={3}>
        {SUCCESS_STUB_TEXTS.CONGRATULATIONS}
      </Typography.Title>
      <Typography.Text className={s.successStub__text} type="secondary">
        {SUCCESS_STUB_TEXTS.DESCRIPTION}
      </Typography.Text>
    </div>
  );
};

export default React.memo(SuccessStub);
